import { defineComponent as _defineComponent } from 'vue'
import { computed, onServerPrefetch } from 'vue';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { ObjectType, SportType } from '@/@types/graphql-types';
import { SnowplowSportContext } from '@/helpers/tracking/providers';
import { SportPageType } from '@/features/sports/types/interfaces';
import { useRoute } from 'vue-router/composables';
import { useNow } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'EventOverview',
  props: {
    startDateTime: null,
    sport: null,
    competitionId: null
  },
  setup(__props: any) {

const props = __props as {
	startDateTime: Date | null;
	sport: SportType;
	competitionId?: number;
};



const route = useRoute();

const now = useNow({ interval: 1000 });

const countdown = computed(() => {
	if (props.startDateTime == null) {
		return {
			days: '00',
			hours: '00',
			minutes: '00',
			seconds: '00',
			isOver: true,
		};
	}
	const delta = new Date(props.startDateTime).getTime() - now.value.getTime();

	return {
		days: formatNumber(delta / (1000 * 60 * 60 * 24)),
		hours: formatNumber((delta % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
		minutes: formatNumber((delta % (1000 * 60 * 60)) / (1000 * 60)),
		seconds: formatNumber((delta % (1000 * 60)) / 1000),
		isOver: delta <= 0,
	};
});

onServerPrefetch(() => {
	// Prevent CLS when countdown loads
	now.value = new Date();
});

// ! Hacky temp fix. Would be good to replace this with a fullPath delivered by the API in the Competition object
const competitionPagePath = computed(() => {
	const fullPath = route.fullPath.toString();
	return fullPath.substring(0, fullPath.lastIndexOf('/'));
});

function trackNavigation() {
	const sportContext = new SnowplowSportContext(props.sport, ObjectType.SportCompetition);
	sportContext.competitionId = props.competitionId;
	TrackingHelper.trackEvent(
		'userinteraction',
		{ action: 'competition_clicked', label: SportPageType.SportEvent, property: 'header', useLastRoute: true },
		[sportContext]
	);
}

const formatNumber = (n: number) => String(Math.floor(n)).padStart(2, '0');

return { __sfc: true,props, route, now, countdown, competitionPagePath, trackNavigation, formatNumber }
}

})